import './Tooltip-5a80d7b2.css';

var classes = {"Tooltip":"prc-TooltipV2-Tooltip-cYMVY","KeybindingHintContainer":"prc-TooltipV2-KeybindingHintContainer-iabqv","HasTextBefore":"prc-TooltipV2-HasTextBefore-cCzYC"};

export { classes as default };
